import React from 'react';
import { connect } from 'react-redux';
import { setActiveText, setTextText, removeTextBlock } from 'components/collage/CollageSlice.js';

// Components
import FreeMove from 'components/misc/free_move/FreeMove.js';

// CSS
import './TextInput.css';

// Images
import TrashIcon from 'img/icons/trash.svg';

class TextInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  componentDidMount() {
    document.getElementById('TextInput-' + this.props.index).addEventListener('input', (event) => {
      this.props.setTextText(event.target.innerText);
    });
  }

  render() {

    let className       = ['TextInput'];
    let textConfig      = this.props.collage.texts[this.props.index];
    let thisTextActive  = parseInt(this.props.collage.activeText) === parseInt(this.props.index);

    if ( thisTextActive ) {
      className.push('TextInput--Highlight');
    }

    return (
      <FreeMove 
        index={this.props.index}
        // highlight={parseInt(this.props.collage.activeText) === parseInt(this.props.index)}
      >
        <div 
          className={className.join(' ')}
          // input={this.handleTextChange}
          style={textConfig}
          id={'TextInput-'+this.props.index}
        >
          Double Click To Edit Me
        </div>

        {thisTextActive &&
          <button 
            class="ButtonReset ButtonTrash"
            title="Remove this text from Collage"
            onClick={() => {
              this.props.removeTextBlock(this.props.index);
            }}
          >
            <img src={TrashIcon} />
          </button>
        }
      </FreeMove>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setActiveText, setTextText, removeTextBlock}
)(TextInput)
